import { render, staticRenderFns } from "./RichTextElement.vue?vue&type=template&id=9c8b147a&"
import script from "./RichTextElement.vue?vue&type=script&lang=js&"
export * from "./RichTextElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports